import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";


@Injectable()
export class JwtService {

  constructor(private http: HttpClient) {
  }

  public getUserProfile(): Observable<any> {
    return this.http.get<any>(`${environment.GATEWAY_URL}/auth/profile`);
  }

}
